import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import TipoDocumentoSerieConstant from 'constants/tipoDocumentoSerie'

const DocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO SERIE' htmlFor='select-tipoSerie' xs={4} lg={5} alignRightAt='xs' />
      <Col xs={8} lg={7}>
        <Field name='tipoSerie'>
          {({ field }) => (
            <Form.Select {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='select-tipoSerie'>
              <option value=''>Seleccionar</option>
              {TipoDocumentoSerieConstant.__array.map((x, k) => (
                <option key={k} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DocumentoFormGroup)
